import { FC } from "react";
import { useUserStore } from "../../stores/user.store";
import { useGetProgramsByIds } from "../../hooks/useBeneficiaries";
import { useSettingsV2 } from "../../hooks/useSetting";
import MultiTreatmentBeneficiaryReport from "./MultiTreatmentBeneficiaryReport";
import LegacyBeneficiaryReport from "./LegacyBeneficiaryReport";

/**
 * Conditional Beneficiary Report Component
 *
 * This component checks if the user has multi-treatment programs:
 * - If YES + useQlikDashboard setting: Shows MultiTreatmentBeneficiaryReport (Qlik-based)
 * - If NO: Shows LegacyBeneficiaryReport (Original API-based)
 */
const BeneficiaryReport: FC = () => {
	const { userInfo } = useUserStore();
	const { data: settings } = useSettingsV2(userInfo?.id);

	// Get user's programs to check for multi-treatment programs
	const programIds =
		userInfo?.programs?.map((program) => program.programId) || [];
	const { data: programs } = useGetProgramsByIds(programIds);

	// Check if user has any multi-treatment programs
	const hasMultiTreatmentProgram = programs?.some(
		(program) => program.multiTreatmentPlan === true,
	);

	// If user has multi-treatment programs and Qlik is enabled, show the new Qlik-based report
	if (hasMultiTreatmentProgram && settings?.useQlikDashboard) {
		return <MultiTreatmentBeneficiaryReport />;
	}

	// Otherwise, show the original API-based report
	return <LegacyBeneficiaryReport />;
};

export default BeneficiaryReport;
